import React, { FC } from 'react';

export const Divider: FC = () => {
	return (
		<div className="divider_horizontal small">
			<div className="thin_line"></div>
		</div>
	);
};
